export const FIELD_TYPE_OPTIONS = [
  'Text',
  'Select',
  'Radio',
  'Number',
  'Custom',
  'Email',
  'Date',
  'Date Time',
  'MultiSelect',
  'Text Area',
  'Checkbox',
];

export const FIELD_ACCESS_OPTIONS = ['Both', 'User'];

export const STATUSES_COLORS = {
  Open: '#FF0000',
  'Under Verification': '#FF6F00',
  Resolved: '#00D82F',
  Closed: '#006FFF',
};

export const STATUSES_PRESET = {
  id: 'default-statuses',
  fieldKey: 'statuses',
  fieldLabel: 'Statuses',
  originalFieldName: 'Statuses',
  fieldType: 'Dropdown',
  required: true,
  fieldAccess: '',
  hideFor: [],
  dependsOn: '',
  options: ['Open', 'Closed', 'Resolved', 'Under Verification'],
  optionColors: { ...STATUSES_COLORS },
  parentMappings: {},
  lockMode: 'options',
  isNew: false,
};

export const PRIORITIES_PRESET = {
  id: 'custom-priorities',
  fieldKey: 'priorities',
  fieldLabel: 'Priorities',
  originalFieldName: 'Priorities',
  fieldType: 'Dropdown',
  required: false,
  fieldAccess: '',
  hideFor: [],
  dependsOn: '',
  options: ['Urgent', 'High', 'Medium', 'Low'],
  parentMappings: {},
  lockMode: 'options',
  isNew: false,
};

export const STORE_ID_PRESET = {
  id: 'custom-store-id',
  fieldKey: 'storeId',
  fieldLabel: 'Store ID',
  originalFieldName: 'Store ID',
  fieldType: 'TextField',
  required: false,
  fieldAccess: '',
  hideFor: [],
  dependsOn: '',
  options: [],
  optionColors: {},
  parentMappings: {},
  lockMode: 'all',
  isNew: false,
};

export const CUSTOM_FIELD_LIBRARY = [
  {
    ...PRIORITIES_PRESET,
    label: PRIORITIES_PRESET.fieldLabel,
  },
  {
    ...STORE_ID_PRESET,
    label: STORE_ID_PRESET.fieldLabel,
  },
];

export function isStatusesField(field) {
  const key = String(field?.fieldKey || '').toLowerCase();
  const label = String(field?.fieldLabel || field?.label || '').trim().toLowerCase();
  return key === 'statuses' || label === 'statuses';
}

export function isPrioritiesField(field) {
  const key = String(field?.fieldKey || '').toLowerCase();
  const label = String(field?.fieldLabel || field?.label || '').trim().toLowerCase();
  return key === 'priorities' || label === 'priorities';
}

export function isStoreIdField(field) {
  const key = String(field?.fieldKey || '').toLowerCase();
  const label = String(field?.fieldLabel || field?.label || '').trim().toLowerCase();
  return key === 'storeid' || label === 'store id';
}

export function isColorOptionsField(field) {
  return isStatusesField(field);
}

export function applyPresetMeta(field) {
  if (isStatusesField(field)) {
    return {
      ...STATUSES_PRESET,
      ...field,
      fieldKey: field.fieldKey || STATUSES_PRESET.fieldKey,
      fieldType: STATUSES_PRESET.fieldType,
      required: true,
      options: field.options?.length ? field.options : STATUSES_PRESET.options,
      optionColors: { ...STATUSES_PRESET.optionColors, ...field.optionColors },
      lockMode: 'options',
    };
  }
  if (isPrioritiesField(field)) {
    return {
      ...PRIORITIES_PRESET,
      ...field,
      fieldKey: field.fieldKey || PRIORITIES_PRESET.fieldKey,
      fieldType: PRIORITIES_PRESET.fieldType,
      options: field.options?.length ? field.options : PRIORITIES_PRESET.options,
      lockMode: 'options',
    };
  }
  if (isStoreIdField(field)) {
    return {
      ...STORE_ID_PRESET,
      ...field,
      fieldKey: field.fieldKey || STORE_ID_PRESET.fieldKey,
      fieldType: STORE_ID_PRESET.fieldType,
      lockMode: 'all',
    };
  }
  return field;
}

export function withDefaultStatuses(fields = []) {
  const mapped = fields.map(applyPresetMeta);
  if (mapped.some(isStatusesField)) return mapped;
  return [applyPresetMeta({ ...STATUSES_PRESET }), ...mapped];
}
